const formatNumberToBRLCurrency = (value: number) =>
	value.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
	});

export {formatNumberToBRLCurrency};
